import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a0d879b568dc7001480a3b5_1784286361449_9a82ad78/easyframe/src/app/register-store/page.tsx");
